angular
    .module('empower.control')
    .directive("datefilter", function () {
        return {
            restrict: 'EA',
            templateUrl: 'module/control/dateFilter/date-filter.html',
            scope: {
                fieldId: '@',
                clearSearch: '&',
                applySearch: '&',
                dateFrom: '=',
                dateTo: '=',
                showSearchDate: '=',
            },
            controller: function ($scope, $timeout, $element) {
                $scope.IdTo = $scope.fieldId + 'To';
                $scope.IdFrom = $scope.fieldId + 'From';
                today = new Date();
                $timeout(function () {
                    $('#' + $scope.IdTo).datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showButtonPanel: true,
                        yearRange: "1900:9999",
                        maxDate: "0Y",
                        onSelect: function (dataText) {
                            $('#' + $scope.IdFrom).datepicker('option', 'maxDate', toDate(dataText));
                            $timeout(function () {
                                $scope.$apply(
                                    $scope.dateTo = dataText
                                );
                            });
                        }
                    });
                    $('#' + $scope.IdFrom).datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showButtonPanel: true,
                        yearRange: "1900:9999",
                        maxDate: "0Y",
                        onSelect: function (dataText) {
                            $('#' + $scope.IdTo).datepicker('option', 'minDate', toDate(dataText));

                            $timeout(function () {
                                $scope.$apply(
                                    $scope.dateFrom = dataText
                                );
                            });
                        }
                    });
                })


                function toDate(dateString) {
                    var dateParts = dateString.split("/");
                    return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
                }
            },
            link: function ($scope, $element) {
                var formatter = "DD-MM-YYYY";
                $scope.onApplyDate = function () {
                    $scope.showSearchDate = false;
                    $scope.applySearch({
                        dateFrom: $scope.dateFrom,
                        dateTo: $scope.dateTo
                    });
                }

                $scope.onClearDate = function () {
                    $scope.dateFrom = null;
                    $scope.dateTo = null;
                    $scope.clearSearch();
                }

                $scope.$watch('dateFrom', function (newValue) {
                    if (ValidDate(newValue, false)) {
                        $("#" + $scope.IdFrom).removeClass('date-error');
                    } else {
                        $("#" + $scope.IdFrom).addClass('date-error');
                    }
                })

                $scope.$watch('dateTo', function (newValue) {
                    if (ValidDate(newValue, true)) {
                        $("#" + $scope.IdTo).removeClass('date-error');
                    } else {
                        $("#" + $scope.IdTo).addClass('date-error');
                    }
                })

                function ValidDate(dateString, To) {

                    if (dateString) {
                        var date = moment(dateString, formatter);
                        if (!date.isValid())
                            return false;
                        if (!CompareDate(date, To))
                            return false;
                    }
                    return true;
                }

                function CompareDate(date, To) {
                    if (To) {
                        var dateStringFrom = $("#" + $scope.IdFrom).val();
                        if (!dateStringFrom)
                            return true;
                        var dateFrom = moment(dateStringFrom, formatter);
                        return date.isAfter(dateFrom);
                    } else {
                        var dateStringTo = $("#" + $scope.IdTo).val();
                        if (!dateStringTo)
                            return true;
                        var dateTo = moment(dateStringTo, formatter);
                        return date.isBefore(dateTo);
                    }
                }

                var onClick = function (event) {
                    if (event.target) {
                        var isClickedElementChildOfPopup = $element
                            .find(event.target)
                            .length > 0;
                        var isClickedFilter = event.target.id == "btn-date-filter" || $("#btn-date-filter").find(event.target)
                            .length > 0;
                        var isClickedCalendar = false;
                        while (event.target) {
                            if (event.target && $(event.target).hasClass('ui-datepicker')) {
                                isClickedCalendar = true;
                                break;
                            }
                            event.target = event.target.parentNode;
                        }
                        if (isClickedElementChildOfPopup || isClickedFilter || isClickedCalendar)
                            return;

                        $scope.$apply(function () {
                            $scope.showSearchDate = false;
                        });
                    }
                }
                $(document).on('click', onClick)

                $scope.$on('$destroy', function() {
                    $(document).off('click', onClick);
                })
                $scope.disableApply = function () {
                    return (!$scope.dateFrom && !$scope.dateTo) || ($("#" + $scope.IdFrom).hasClass('date-error') || $("#" + $scope.IdTo).hasClass('date-error'));
                }
            }
        }

    })